import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const TimeFormContainer = styled.div``;

export const TimeFormBody = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;

  padding: ${({ theme }) => `${theme.spacing(2.5)} ${theme.spacing(4)}`};
`;

export const TimeInput = styled.input<{ $alignedRight?: boolean }>`
  flex: 1;
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  width: 8rem;
  padding: 0;
  margin: 0;

  border: none;
  outline: none;
  background: transparent;

  color: ${({ theme }) => theme.palette.text.primary};

  ${({ $alignedRight }) =>
    $alignedRight &&
    css`
      text-align: right;
    `};
`;

export const TimeSeparator = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const TimeFormFooter = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(2)};

  border-top: 1px solid ${({ theme }) => theme.palette.divider};
`;
